import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { format as dateFormat } from 'date-fns';
import { getDurationTime } from '../../utils/date';

class Countdown extends React.PureComponent {
  static formattedValue(seconds, format = 'HH:mm:ss') {
    const dutation = getDurationTime({ seconds });
    return dateFormat(dutation, format);
  }

  constructor(props) {
    super(props);

    this.state = {
      seconds: props.seconds,
    };
  }

  componentDidMount() {
    this.launch();
  }

  componentWillUnmount() {
    this.reset();
  }

  launch() {
    this.reset();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  reset() {
    clearInterval(this.timer);
  }

  tick() {
    const { onStop } = this.props;

    this.setState(prevState => {
      if (prevState.seconds <= 0) {
        this.reset();

        onStop();

        return {
          seconds: 0,
        };
      }

      return {
        seconds: prevState.seconds - 1,
      };
    });
  }

  render() {
    const { seconds } = this.state;
    const { format, ...props } = this.props;

    if (!seconds) {
      return null;
    }

    return (
      <StyledCountdown {...props}>
        {Countdown.formattedValue(seconds, format)}
      </StyledCountdown>
    );
  }
}

Countdown.propTypes = {
  onStop: PropTypes.func,
  className: PropTypes.string,
  format: PropTypes.string,
  seconds: PropTypes.number.isRequired,
};

Countdown.defaultProps = {
  className: '',
  format: 'HH:mm:ss',
  onStop: Function.prototype,
};

const StyledCountdown = styled.div`
  font-size: 17px;
  font-weight: bold;
`;

export default Countdown;
